import React, { Component } from "react";
import { Modal } from "antd";
import _ from "lodash";

import { withRedux } from "../../hoc";

const checkHasPopup = props => {
  const { t, popupImageDesktop, popupImageMobile } = props;
  const popupImageDesktopFile = _.get(t(popupImageDesktop), "full_file_path");
  const popupImageMobileFile = _.get(t(popupImageMobile), "full_file_path");
  return !!popupImageDesktopFile || !!popupImageMobileFile;
};

const mapStateToProps = ({ language, t, home }) => {
  return {
    language,
    t,
    popupImageDesktop: _.get(home, "data.media_image_popup_desktop_data"),
    popupImageMobile: _.get(home, "data.media_image_popup_mobile_data")
  };
};

const actionToProps = {};

@withRedux(mapStateToProps, actionToProps)
export default class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preShowPopup: false,
      showPopup: false
    };
  }

  static getDerivedStateFromProps(props, state) {
    const hasPopup = checkHasPopup(props);
    if (hasPopup !== state.preShowPopup) {
      return {
        preShowPopup: hasPopup,
        showPopup: hasPopup
      };
    }
    return null;
  }

  render() {
    const { t, popupImageDesktop, popupImageMobile } = this.props;
    const { showPopup } = this.state;
    const popupImageDesktopFile = _.get(t(popupImageDesktop), "full_file_path");
    const popupImageMobileFile = _.get(t(popupImageMobile), "full_file_path");
    return (
      <Modal
        className="popup-image"
        width="initial"
        centered
        visible={showPopup}
        footer={null}
        onCancel={() => this.setState({ showPopup: false })}
        destroyOnClose
      >
        <img
          className="desktop"
          src={popupImageDesktopFile || popupImageMobileFile}
          alt=""
        />
        <img
          className="mobile"
          src={popupImageMobileFile || popupImageDesktopFile}
          alt=""
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Popup.js